import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56388bea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "solution-service__wrap"
};
const _hoisted_2 = {
  class: "solution-service__content"
};
const _hoisted_3 = {
  class: "solution-service__card-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "solution-service__card-btn"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-arrow"
}), /*#__PURE__*/_createTextVNode("了解更多")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardList, (row, index) => {
    return _openBlock(), _createBlock(_component_el_row, {
      key: index,
      gutter: 30,
      class: "solution-service__card-row"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, col => {
        return _openBlock(), _createBlock(_component_el_col, {
          key: col.skuid,
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            class: "solution-service__card",
            to: `/solution/detail/${col.spuid}/${col.skuid}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: "solution-service__card-icon",
              style: _normalizeStyle({
                backgroundImage: `url(${col.icon})`
              })
            }, null, 4), _createElementVNode("h3", _hoisted_3, _toDisplayString(col.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.descList, (des, i) => {
              return _openBlock(), _createElementBlock("p", {
                key: `${index}_${i}`,
                class: "solution-service__card-des"
              }, _toDisplayString(des), 1);
            }), 128)), _hoisted_4]),
            _: 2
          }, 1032, ["to"])]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 2
    }, 1024);
  }), 128))])]);
}